import React from "react";
import { useState } from 'react';
import { Link } from "react-router-dom";
import "./Banner.css";

function Banner()
{
    const [loaded, setLoaded] = useState(false);

    return(
        <header className="banner">
            <Link to="/">
            <div className="overlay">
                <img src="/logoBanner.png" 
                    alt="Laurelia" 
                    className="logo" 
                    loading="eager"
                    onLoad={() => setLoaded(true)}
                    style={{
                        width: '100%',
                        height: 'auto',
                        opacity: loaded ? 1 : 0,
                        transition: 'opacity 2s ease-in-out',
                        width: '180px',
                        transitionDelay: '0.3s'
                    }}          
                />
                <h1
                className="text-overlay"
                style={{
                    opacity: loaded ? 1 : 0,
                    transition: 'opacity 0.5s ease-in-out',                   
                }}
                >
                Laurelia
                </h1>
            </div>  
            </Link>  
        </header>
    );

};

export { Banner };